import { useEffect, useState } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import '../styles/About.css';

import aboutImg from '../assets/about-image.jpg';
import aboutImg1 from '../assets/about-image1.jpg';
import isoImg from '../assets/iso-certificate.jpg';

export default function About() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const element = document.querySelector('.fade-in-section');
      if (!element) return;

      const rect = element.getBoundingClientRect();
      if (rect.top < window.innerHeight - 100) {
        setVisible(true);
      }
    };

    window.addEventListener('scroll', onScroll);
    onScroll(); // trigger on mount

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section className="about-section py-5 bg-custom-dark text-custom-light">
      <Container>
        {/* About SE block */}
        <Row className="align-items-center">
          <Col md={6} className="mb-4 mb-md-0">
            <h2>About Sanjay Enterprises</h2>
            <p>
              Sanjay Enterprises has been a trusted name in precision manufacturing.
              Our dedication to quality, innovation, and reliability has earned us a solid reputation
              in the oilfield, automotive, defense, and prototyping industries.
              Located in Pune, we are strategically positioned to serve clients across India, Europe and The UAE.
            </p>
            <p>
              We believe in building long-term partnerships through trust, technical excellence,
              and customer-first service. Our team brings years of expertise to deliver tailored
              manufacturing solutions that exceed expectations.
            </p>
            <p>
              At Sanjay Enterprises, we are committed to continuous improvement and sustainability.
              We invest in the latest technologies and practices to ensure our processes are efficient
              and environmentally responsible.
            </p>
          </Col>
          <Col md={6}>
            <Image src={aboutImg} fluid rounded alt="About Sanjay Enterprises" />
          </Col>
        </Row>

        <hr className="my-5 border-secondary" />

        {/* Mission/Vision block */}
        <div className={`fade-in-section ${visible ? 'visible' : ''}`}>
          <Row className="text-center">
            <Col md={6} className="mb-0">
              <h3 className="text-uppercase">Our Mission</h3>
              <p>
                To deliver precision-engineered manufacturing solutions that exceed client expectations
                and contribute to the growth of industries worldwide.
                We aim to deliver value through consistent quality, customer-focused solutions, and continuous innovation.

              </p>
            </Col>
            <Col md={6}>
              <h3 className="text-uppercase">Our Vision</h3>
              <p>
                To establish ourselves as a globally recognized name in custom and
                high-performance machining — empowering industries with parts they can rely on.
                We envision a future where our innovations drive progress and sustainability in manufacturing.
              </p>
            </Col>
          </Row>
        </div>

        <hr className="my-5 border-secondary" />

        {/* Why Choose us */}
        <Row className="align-items-center">
          <Col md={6}>
            <Image src={aboutImg1} fluid rounded alt="About Sanjay Enterprises" />
          </Col>
          <Col md={6} className="mb-4 mb-md-0">
            <h2>Why Choose Us</h2>
            <p>
              <b>Versatile Approach:</b> We undertake both material-based and labour-based projects to meet varied client requirements.
            </p>
            <p>
              <b>Precision You Can Trust:</b> We specialize in high-accuracy machining with tolerances upto ±0.01 mm — ensuring every part fits and performs perfectly.
            </p>
            <p>
              <b>Custom Solutions:</b> No two projects are the same. We tailor our approach to suit your design, material, tolerance, and finishing needs — whether it’s one part or ten thousand.
            </p>
            <p>
              <b>Quick Turnarounds:</b> We understand time is critical. Our team is committed to on-time delivery without cutting corners on quality.
            </p>
            <p>
              <b>Future-Focused:</b> We're actively expanding into defense and international markets. Investing in new tech and skills to serve clients better.
            </p>
            <p>
              <b>Trust & Transparency:</b> With us, you get honest timelines, fair pricing, and full project visibility.
            </p>
            <p>
              <b>Made in India. Trusted Worldwide:</b> Rooted in Pune's manufacturing hub, we aim to showcase Indian precision engineering to the global market.
            </p>
          </Col>
        </Row>

        <hr className="my-5 border-secondary" />

        {/* ISO Certificate */}
        <Row className="align-items-center">
          <Col md={6} className="mb-4 mb-md-0">
            <h2>We are Certified!</h2>
            <p>
              Sanjay Enterprises is proud to be ISO 9001:2015 certified. This certification reflects our commitment to quality management and continuous improvement.
              It ensures that we consistently provide products and services that meet 'customer and regulatory requirements'.
            </p>
          </Col>
          <Col md={6}>
            <Image style={{ width: 'auto', height: '40rem', paddingLeft: '4rem' }} 
                    src={isoImg} fluid alt="Sanjay Enterprises ISO Certification" />
          </Col>
        </Row>

        <hr className="my-5 border-secondary" />

        {/* Core Values */}

        <section className="core-values-section mt-5 py-5 bg-custom-light">
          <div className="container text-center">
            <h2 className="mb-4">Core Values</h2>
            <div className="row">
              <div className="col-md-3 col-sm-6 mb-4">
                <div className="value-card p-3 h-100 shadow-sm">
                  <i className="bi bi-shield-lock fs-1 text-primary mb-2"></i>
                  <h5>Integrity</h5>
                  <p>We uphold a range of qualities and behaviors that reflect honesty, ethics, and consistency.</p>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 mb-4">
                <div className="value-card p-3 h-100 shadow-sm">
                  <i className="bi bi-lightbulb fs-1 text-warning mb-2"></i>
                  <h5>Innovation</h5>
                  <p>We constantly strive to redefine the standard of excellence in everything we do.</p>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 mb-4">
                <div className="value-card p-3 h-100 shadow-sm">
                  <i className="bi bi-people fs-1 text-success mb-2"></i>
                  <h5>Teamwork</h5>
                  <p>We work together to meet the needs of our customers and to help the company win.</p>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 mb-4">
                <div className="value-card p-3 h-100 shadow-sm">
                  <i className="bi bi-award fs-1 text-danger mb-2"></i>
                  <h5>Excellence</h5>
                  <p>We deliver our expertise in the form of highly favourable solutions to our customers.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="contact-section py-5 bg-custom-dark text-custom-light">
          <Container>
            <Row>
              <Col md={12} className="text-center">
                <h2>Get in Touch</h2>
                <p>Ready to discuss your project? Contact us today!</p>
                <a href="/contact" className="btn btn-primary">Contact Us</a>
              </Col>
            </Row>
          </Container>
        </section>

      </Container>
    </section>
  );
}
